





import { Component, Vue } from 'vue-property-decorator';
import CompleteView from '@/components/CompleteView.vue';

@Component({
  components: {
    CompleteView
  }
})
export default class Parts extends Vue {
  private get isComplete(): boolean {
    // 完了状態になったら強制的に完了画面を表示する 最初のページとエラーページは除く
    if (this.$route.name === 'launch') return false;
    if (this.$route.name === 'application-error') return false;
    return this.$store.getters['completion/isComplete'];
  }
}
